import React, { useState, useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { CSVLink } from "react-csv";
import axios from 'axios';
import apiUrl from '../../../Apiurl';
//IMPORT SPECIFICI
import BarraContatti from './BarraContatti';
import ListaContatti from './ListaContatti';
import stilePulsanti from '../../../interfaccia/stilePulsanti';


function PaginaContatti({
    mobile,
    utente,
    elemento,
    setElemento
}) {

    const urlArea = "/anagrafiche/listaContatti";
    const urlElemento = "/anagrafiche/apriContatto/";
    const elementoBlank = {
        id: null,
        nome: null,
        mail: null,
        cc: null,
        cell: null,
        rappresentante: 0,
        warranty: 0,
        immagini: 0,
        ean: 0,
        note: null,
        obsoleto: 0,
        cell2: null,
        customer: 0
    }

    const headers = [
        { label: "id", key: "id" },
        { label: "obsoleto", key: "obsoleto" },
        { label: "nome", key: "nome" },
        { label: "mail", key: "mail" },
        { label: "cell", key: "cell" },
        { label: "cell2", key: "cell2" },
        { label: "cc", key: "cc" },
        { label: "fornitori", key: "arrFornitori" },
        { label: "brands", key: "arrBrands" },
        { label: "rappresentante", key: "rappresentante" },
        { label: "warranty", key: "warranty" },
        { label: "immagini_marketing", key: "immagini" },
        { label: "ean_rif_tecnico", key: "ean" },
        { label: "customer_service", key: "customer" },
        /* { label: "note", key: "note" } */ //TOLGO TEMPORANEAMENTE LE NOTE PERCHE' GLI "A CAPO" DANNO PROBLEMI AD EXCEL
      ];

    ////////////////////       HOOKS GENERICI      ///////////////////////////
    const [lista, setLista] = useState([]);
    const [loading, setLoading] = useState(false);
    const [filterText, setFilterText] = useState('');
    const [filterTextBrand, setFilterTextBrand] = useState('');
    /* const filteredItemsNome = lista.filter(
		item => item.nome && item.nome.toLowerCase().includes(filterText.toLowerCase()),
	); */
    let filteredItems;
    if (filterText.length>2) {
        filteredItems = lista.filter(
            item => item.nome && item.nome.toLowerCase().includes(filterText.toLowerCase()),
        );
    }
    if (filterTextBrand.length>1) {
        filteredItems = lista.filter(
            item => item.arrBrands.flat().join().includes(filterTextBrand.toUpperCase())
        );
    } 


    ////////////////////       AUTENTICAZIONE      ///////////////////////////
    const { user, /* isAuthenticated, */ getAccessTokenSilently } = useAuth0();
    const [token, setToken] = useState("");
    useEffect(() => {
        const getUserMetadata = async () => {
            try {
                const accessToken = await getAccessTokenSilently();
                setToken(accessToken);
            } catch (e) {
                console.log(e.message);
            }
        };
        getUserMetadata();
    }, [getAccessTokenSilently, user?.sub]);
    //////////////////////////////////////////////////////////////////////////

    ////////////////////       FETCH INIZIALE      ///////////////////////////
    const fetchOrdini = async () => {
        setLoading(true);
        const response = await axios.get(apiUrl + urlArea);
        console.log(response.data)
        setLista(response.data);
        setLoading(false);      
    };

    useEffect(() => {
        if (!token) {
            console.warn("sto aspettando un token")
            return;
        }
        fetchOrdini()
    }, [token]);
    //////////////////////////////////////////////////////////////////////////


    ////////////////////       FETCH ELEMENTO      ///////////////////////////
    const apriElemento = async function(id) {
        if (!token) {
            console.warn("sto aspettando un token")
            return;
        }
        fetch(apiUrl + urlElemento+id, { headers: { Authorization: "Bearer " + token } })
            .then(resp => resp.json())
            .then(data => setElemento(data))
    }
    //////////////////////////////////////////////////////////////////////////

    ////////////////////       CREA ELEMENTO      ///////////////////////////
    const creaNuovoElemento = function(){
        setElemento(elementoBlank)
    }
    //////////////////////////////////////////////////////////////////////////

    return (
        <div>
            
                <div className='barraelista'>
                    <BarraContatti 
                        elemento={elemento}
                        creaNuovoElemento={creaNuovoElemento}
                        apriElemento={apriElemento}
                        mobile={mobile}
                        utente={utente}
                        filterText={filterText}
                        setFilterText={setFilterText}
                        filterTextBrand={filterTextBrand}
                        setFilterTextBrand={setFilterTextBrand}
                    />
                    {lista && <ListaContatti
                        elemento={elemento}
                        apriElemento={apriElemento}
                        mobile={mobile}
                        utente={utente}
                        lista={filteredItems ? filteredItems : lista}
                        loading={loading}
                    />}
                    {lista && <CSVLink 
                        data={lista} 
                        headers={headers} 
                        separator={";"} 
                        enclosingCharacter={``} 
                        className={stilePulsanti.buttonClassesWhite} 
                        target="_blank" 
                        filename={"export_contatti.csv"}>
                        scarica csv
                    </CSVLink>}
                </div>
        </div>
    )
}

export default PaginaContatti;